import { useAuth } from "react-oidc-context";

export function useIsAdmin(): boolean {
  const { user } = useAuth();

  if (!user) {
    return false;
  }

  const zitadelRoles = user.profile["urn:zitadel:iam:org:project:roles"] as
    Record<string, unknown> | undefined;
  if (
    zitadelRoles &&
    Object.prototype.hasOwnProperty.call(zitadelRoles, "admin")
  ) {
    return true;
  }

  const rolesKey = Object.keys(user.profile).find((key) =>
    key.startsWith("roles:"),
  );
  if (!rolesKey) {
    console.warn("Could not determine roles for user");
    return false;
  }

  return (user.profile[rolesKey] as Array<string>).includes("admin");
}
